module.exports = __webpack_public_path__ + "static/media/full_7.bccb6cf6.jpg";